import React, { Component } from 'react';

import '../styles/containers/Activities.css';
import { AxiosError } from 'axios';

import * as Service from '../services/CityGuideService';
import { uploadImage } from '../api/ImageApi';
import Spinner from '../components/utils/Spinner';
import EntertainmentScreen from '../components/cityGuides/entertainments/EntertainmentsScreen';

class State {
  entertainmentsLoaded = false;
  entertainments = [];
  deactive = false;
  isError = false;
}

export class Entertainments extends Component {
  state = new State();

  async componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
    const entertainments = await Service.getEntertainmments();
    const ent = entertainments.map(elem => ({
      ...elem,
      picture: { isNew: false, data: elem.picture },
    }));
    this.setState({ entertainments: ent, entertainmentsLoaded: true });
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  hideMessage = () => {
    this.setState({ isError: false });
  };

  updateEntertainment = async entertainment => {
    try {
      const data = Service.putEntertainment(entertainment);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  deleteEntertainment = async id => {
    try {
      Service.deleteEntertainment(id);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  getImageUrl = async (type, id) => {
    try {
      const data = Service.getUrlForImage(type, id);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  uploadImage = async (url, image) => {
    try {
      uploadImage(url, image);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  changeState = data => {
    this.setState(prevState => {
      const newState = {
        ...prevState,
        ...data,
      };
      return newState;
    });
  };

  addEntertainment = async value => {
    let { entertainments } = this.state;
    const entertainment = {
      ...value,
      id: await this.uploadImg(value.picture, value.id, 'entertainments'),
      picture: undefined,
    };
    let newEntertainment = await this.updateEntertainment(entertainment);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const ent = entertainments.find(elem => elem.id === newEntertainment.id);
    if (ent) {
      newEntertainment = {
        ...newEntertainment,
        picture: value.picture,
      };
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      entertainments[entertainments.indexOf(ent)] = newEntertainment;
    } else {
      newEntertainment = {
        ...newEntertainment,
        picture: value.picture,
      };
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      entertainments = [newEntertainment, ...entertainments];
    }
    this.setState(prevState => {
      const newState = {
        ...prevState,
        entertainments: [...entertainments],
      };
      return newState;
    });
  };

  uploadImg = async (image, id, type) => {
    if (image.isNew) {
      const urlData = await this.getImageUrl(type, id);
      await this.uploadImage(urlData.url, image.blob);
      return urlData.id;
    }
    return id;
  };

  render() {
    const { entertainmentsLoaded, entertainments } = this.state;
    const entertainmentsActions = {
      updateEntertainment: this.updateEntertainment,
      deleteEntertainment: this.deleteEntertainment,
      getUrlForImage: this.getImageUrl,
      uploadImage: this.uploadImage,
    };
    if (!entertainmentsLoaded) {
      return <Spinner />;
    }
    return (
      <EntertainmentScreen
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        entertainments={entertainments}
        addEntertainment={this.addEntertainment}
        changeState={this.changeState}
        actions={entertainmentsActions}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        back={this.back}
      />
    );
  }
}
